module.exports = __webpack_public_path__ + "img/blog.1d1e7efe.svg";